import React from "react";
//import cfgs from './tiles.json';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
//import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
//import Orders from '../pages/old/dashboard-orders';
import DataPreview from "./data-preview-panel";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '75%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function ModalDataPreview(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  
  //const preview_query = props.preview_query;
  //console.log(`PREVIEW_QUERY=${preview_query}`)
  return (
    <div>
      <Button onClick={handleOpen}>{props.button_title}</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          
          <DataPreview {...props}/>
        </Box>
      </Modal>
    </div>
  );
}